import { Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { AuthScreen } from '@/features/auth/AuthScreen';

/**
 * Auth-гейт (AUTH-1): неавторизованный видит экран входа на том же адресе —
 * deep-link (`?video=`) сохраняется до входа. Неподтверждённый email в каталог
 * не пускает (AUTH-11).
 */
export function RequireAuth() {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <AuthScreen mode="login" />;
  if (user && !user.emailVerified) return <AuthScreen mode="verify" />;
  return <Outlet />;
}
